import * as React from "react";

import { Svg } from "@/assets";
import * as DTO from "../../../interfaces";
import { URLS } from "@/utils";

import moment from "moment";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui";

export interface VideoProjectEditorCardRecord extends DTO.PlayerVideoProjectResponse {
  assigneeName: string | null;
}

interface Props {
  videoProject: VideoProjectEditorCardRecord;
  disabled: boolean;
}

const VideoProjectEditorCardFC: React.FC<Props> = ({
  videoProject: {
    videoProjectId,
    statusLabel,
    thumbnail,
    companyName,
    playerName,
    statusDate,
    needsAck,
    assigneeName,
    revisionCount,
  },
  disabled,
}: Props) => {
  return (
    <a
      className={cn(
        "block w-[150px] relative bg-[#fafafa] rounded-[6.3px] border border-[#d4d4d4] transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-lg hover:border-slate-400 group overflow-hidden text-sm",
        needsAck && "border-[#ff9900] rounded-[10px] hover:border-[#ff9900]",
        disabled && "opacity-50 pointer-events-none"
      )}
      href={URLS.editor.editVideo.replace(":id", `${videoProjectId}`)}
    >
      <Badge
        variant="secondary"
        className={cn(
          "absolute top-2 left-2 z-10 font-mono text-[10px] px-1.5 py-0.5 shadow-sm backdrop-blur-xs pointer-events-none",
          !revisionCount || revisionCount <= 0
            ? "bg-white/90 text-slate-700 border-slate-200"
            : revisionCount === 1
            ? "bg-amber-100 text-amber-900 border-amber-300"
            : revisionCount === 2
            ? "bg-orange-200 text-orange-900 border-orange-400"
            : "bg-red-200 text-red-900 border-red-400"
        )}
      >
        #{videoProjectId}
      </Badge>

      <div className="w-full h-[110px] overflow-hidden bg-[#eaeaf0]">
        <img
          src={thumbnail?.thumbnailUri || Svg.PromptPlaceholder}
          alt=""
          className={cn(
            "w-full h-full transition-transform duration-300 ease-out group-hover:scale-105",
            thumbnail?.thumbnailUri ? "object-cover object-center" : "object-none object-center"
          )}
        />
      </div>
      <div className="p-2.5 flex flex-col gap-1 select-none">
        <div className="font-semibold text-xs tracking-tight text-slate-800 truncate text-left">{playerName}</div>
        <div className="font-semibold text-[11px] tracking-tight text-slate-700 truncate text-left">
          {companyName || "-"}
        </div>
        <div className="text-[11px] tracking-tight text-slate-500 text-left truncate">{statusLabel}</div>
        <div className="text-[11px] tracking-tight text-slate-500 text-left truncate">
          {moment(statusDate!!).format("MMM DD, YY [at] hh:mm a")}
        </div>
        <div className="text-[11px] tracking-tight text-slate-500 text-left truncate">
          {assigneeName ? `Assignee: ${assigneeName}` : "Unassigned"}
        </div>
      </div>
    </a>
  );
};

export const VideoProjectEditorCard = VideoProjectEditorCardFC;
